import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Space, Typography } from "antd"
import { green, blue } from "@ant-design/colors"
import { CheckCircleOutlined, HourglassOutlined } from "@ant-design/icons"

import hasAccess from "@api/hasAccess"
import { useAppContext } from "@components/AppContext"
import { OrganizationShape } from "@shapes"

const { Text } = Typography

const operation = "organizations/UpdateMyOrganizationEmailVerificationStatus"


const OrganizationEmail = ({ organization, updateOrganization }) => {
  const { request } = useAppContext()
  const { email, isEmailVerified } = organization

  const canUpdateOrganization = hasAccess(['org-write'])

  const emailStatusIcon = isEmailVerified
    ? <CheckCircleOutlined style={{ color: green.primary }} />
    : <HourglassOutlined style={{ color: blue.primary }} />

  const isEmailVerifiedSet = isEmailVerified !== undefined

  let isInProgress = false
  useEffect(() => {
    if (isInProgress) { return }
    isInProgress = true

    if (!canUpdateOrganization) {
      return
    }

    const isEmailVerificationStatusUnknown = isEmailVerified === undefined

    if (isEmailVerificationStatusUnknown) {
      return
    }

    if (isEmailVerified) {
      return
    }

    request(operation)
      .then(({ data: updatedOrganization }) => updateOrganization(updatedOrganization))
  }, [ isEmailVerified ])

  return (
    <Space>
      <Text>{email}</Text>

      { isEmailVerifiedSet && emailStatusIcon }
    </Space>
  )
}

OrganizationEmail.propTypes = {
  organization: OrganizationShape.isRequired,
  updateOrganization: PropTypes.func.isRequired,
}

export default OrganizationEmail
